










































import { Component, Inject, Vue, Prop, Watch } from 'vue-property-decorator';
import { EventBus } from '../../event-bus';
import { mapGetters } from 'vuex';
import axios from 'axios';
import Swal from 'sweetalert2';

@Component({
  props: ['isSetPasswordVisible', 'form'],
})
export default class SetPasswordModal extends Vue {
   @Inject() parentValidator: any;

  @Prop()
  isSetPasswordVisible: any;

  @Prop()
  form: any;

    protected created() {
        this.$validator = this.parentValidator;
    }
}   
